export const heroData = {
  title: "Cancellation Policy",
  subtitle: "Please review our cancellation policy before booking. We want you to feel confident every step of the way.",
  image:
    "https://readdy.ai/api/search-image?query=Calm%20serene%20sky%20with%20soft%20clouds%20during%20sunset%2C%20peaceful%20and%20reassuring%20atmosphere%2C%20deep%20navy%20blue%20and%20warm%20gold%20gradient%20sky%2C%20minimalist%20nature%20photography%2C%20no%20text%2C%20high%20quality&width=1920&height=600&seq=cancelhero01&orientation=landscape",
};

export const policyData = {
  label: "POLICY",
  title: "Cancellation Terms",
  items: [
    {
      period: "8 or more days before flight",
      fee: "Free",
      desc: "No cancellation fee. Date changes are also available.",
    },
    {
      period: "7 to 2 days before flight",
      fee: "30% of total price",
      desc: "A cancellation fee applies. One date change is permitted.",
    },
    {
      period: "1 day before flight",
      fee: "50% of total price",
      desc: "A cancellation fee applies. Same-day changes are not available.",
    },
    {
      period: "Day of flight / No-show",
      fee: "100% of total price",
      desc: "Full cancellation fee applies.",
    },
  ],
};

export const weatherPolicy = {
  label: "WEATHER",
  title: "Cancellations Due to Weather",
  items: [
    "Safety is our top priority. Flights may be cancelled due to poor visibility, strong winds, or thunderstorms at the operator's discretion.",
    "Weather decisions are typically made on the morning of the flight date.",
    "In the event of a weather cancellation, you may choose to reschedule or receive a full refund.",
    "No cancellation fee applies for weather-related cancellations.",
    "If conditions look unstable, our staff may contact you in advance.",
  ],
};

export const otherNotes = {
  label: "NOTE",
  title: "Additional Notes",
  items: [
    "Changes to your reservation (date or number of guests) must be requested at least 7 days before the flight.",
    "Price reductions due to a decrease in the number of guests are generally not available.",
    "Gift tickets are valid for 6 months from the date of purchase.",
    "Gift ticket refunds are available within 7 days of purchase only.",
    "Cancellations due to special circumstances (illness, natural disasters, etc.) will be considered on a case-by-case basis.",
  ],
};
